export default function Footer() {
  const scrollToAnchor = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) {
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 64, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-surface-950 border-t border-surface-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollToAnchor('#hero'); }}
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-brand-500 rounded-lg">
                <i className="ri-fire-line text-white text-lg"></i>
              </span>
              <span className="text-white font-display text-xl tracking-wide">每日大赛</span>
            </a>
            <p className="text-surface-400 text-sm leading-relaxed">
              每日大赛官网 — 一手黑料吃瓜赛事入口。聚合全网娱乐资讯，每日更新明星动态、综艺翻车、片场爆料等全品类吃瓜内容。最新地址一站直达，多重信源交叉验证，做你最靠谱的吃瓜指南。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-surface-800 text-surface-400 hover:text-white hover:bg-brand-500 transition-all duration-200 cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-surface-800 text-surface-400 hover:text-white hover:bg-brand-500 transition-all duration-200 cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-surface-800 text-surface-400 hover:text-white hover:bg-brand-500 transition-all duration-200 cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热搜吃瓜榜', anchor: '#ranking' },
                { label: '每日大赛APP', anchor: '#app' },
                { label: '焦点专题', anchor: '#carousel' },
                { label: '热门吃瓜', anchor: '#cards' },
                { label: '视频专区', anchor: '#media' },
                { label: '最新动态', anchor: '#updates' },
              ].map((item) => (
                <a
                  key={item.anchor}
                  href={item.anchor}
                  onClick={(e) => { e.preventDefault(); scrollToAnchor(item.anchor); }}
                  className="text-surface-400 hover:text-brand-400 text-sm transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">关于我们</h3>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '关于每日大赛', anchor: '#about' },
                { label: '投稿爆料', anchor: '#contact' },
                { label: '常见问答', anchor: '#faq' },
              ].map((item) => (
                <a
                  key={item.anchor}
                  href={item.anchor}
                  onClick={(e) => { e.preventDefault(); scrollToAnchor(item.anchor); }}
                  className="text-surface-400 hover:text-brand-400 text-sm transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">合作伙伴</h3>
            <p className="text-surface-500 text-sm leading-relaxed">
              每日大赛与多家娱乐媒体、行业机构保持深度合作关系，共同为用户提供优质内容服务。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {['娱乐资讯', '赛事报道', '明星动态', '综艺观察'].map((tag) => (
                <span key={tag} className="px-3 py-1 text-xs text-surface-400 bg-surface-800 rounded-md">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-surface-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-surface-500 text-xs">
            &copy; {new Date().getFullYear()} 每日大赛官网 版权所有 | 本站内容仅供娱乐参考
          </p>
          <p className="text-surface-600 text-xs">
            每日大赛入口 · 每日大赛APP · 每日大赛网站最新地址一站式直达
          </p>
        </div>
      </div>
    </footer>
  );
}